module.exports = __webpack_public_path__ + "static/media/lists.900571c8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/lists.svg
// module id = 859
// module chunks = 0